import clsx from 'clsx'
import { Moon, Sun, SunMoon } from 'lucide-react'
import { ThemeModeComponent } from '../../../assets/ts/layout'
import { ThemeModeType, useThemeMode } from './ThemeModeProvider'
import { useIntl } from 'react-intl'

type Props = {
  toggleBtnClass?: string
  toggleBtnIconClass?: string
  menuPlacement?: string
  menuTrigger?: string
}

const systemMode = ThemeModeComponent.getSystemMode() as 'light' | 'dark'

const ThemeModeSwitcher = ({
  toggleBtnClass = '',
  toggleBtnIconClass = 'fs-1',
  menuPlacement = 'bottom-end',
  menuTrigger = "{default: 'hover', lg: 'hover'}",
}: Props) => {
  const { mode, menuMode, updateMode, updateMenuMode } = useThemeMode()
  const calculatedMode = mode === 'system' ? systemMode : mode
  const switchMode = (_mode: ThemeModeType) => {
    updateMenuMode(_mode)
    updateMode(_mode)
  }
  const intl = useIntl()

  return (
    <>
      {/* begin::Menu toggle */}
      <div
        className={clsx('btn btn-icon', toggleBtnClass)}
        data-kt-menu-trigger={menuTrigger}
        data-kt-menu-attach='parent'
        data-kt-menu-placement={menuPlacement}
      >
        {calculatedMode === 'dark' && (
          <Moon className={toggleBtnIconClass} size={24} />
        )}

        {calculatedMode === 'light' && (
          <Sun className={toggleBtnIconClass} size={24} />
        )}
      </div>
      {/* begin::Menu toggle */}

      {/* begin::Menu */}
      <div
        className='py-4 menu-rounded w-175px menu menu-sub menu-sub-dropdown menu-column menu-title-gray-700 menu-icon-muted menu-active-bg menu-state-primary fw-semibold fs-base'
        data-kt-menu='true'
      >
        {/* begin::Menu item */}
        <div className='my-0 px-3 menu-item'>
          <a
            href='#'
            className={clsx('px-3 py-2 menu-link', { active: menuMode === 'light' })}
            onClick={() => switchMode('light')}
          >
            <span className='menu-icon' data-kt-element='icon'>
              <Sun size={24} />
            </span>
            <span className='menu-title'>{intl.formatMessage({ id: 'Light' })}</span>
          </a>
        </div>
        {/* end::Menu item */}

        {/* begin::Menu item */}
        <div className='my-0 px-3 menu-item'>
          <a
            href='#'
            className={clsx('px-3 py-2 menu-link', { active: menuMode === 'dark' })}
            onClick={() => switchMode('dark')}
          >
            <span className='menu-icon' data-kt-element='icon'>
              <Moon size={24} />
            </span>
            <span className='menu-title'>{intl.formatMessage({ id: 'Dark' })}</span>
          </a>
        </div>
        {/* end::Menu item */}

      </div>
      {/* end::Menu */}
    </>
  )
}

export { ThemeModeSwitcher }
